import React, { useId } from 'react';
import './AptiviewLoader.css';

/**
 * Branded Aptiview loader (v2).
 * Shown while data is loading and removed as soon as data is ready.
 * Use FullScreenLoader / usePageLoading for page-level data loads.
 */
export default function AptiviewLoader({
  message = 'Getting your interview space ready…',
  showWordmark = true,
  size = 'md',
  className = '',
  variant = 'inline',
  active = true,
}) {
  const reactId = useId().replace(/:/g, '');
  const gradientId = `apti-loader-g-${reactId}`;

  if (!active) return null;

  const variantClass =
    variant === 'fullscreen'
      ? 'apti-loader--fullscreen'
      : variant === 'content'
        ? 'apti-loader--content'
        : 'apti-loader--inline';

  const rootClass = [
    'apti-loader',
    variantClass,
    'apti-loader--play',
    size === 'sm' ? 'apti-loader--sm' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass} role="status" aria-live="polite" aria-label={message || 'Loading'}>
      <div className="apti-loader__mark">
        <div className="apti-loader__glow" aria-hidden="true" />
        <svg className="apti-loader__svg" viewBox="0 0 120 120" aria-hidden="true">
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor="#0096e6" />
              <stop offset="0.55" stopColor="#6a7be8" />
              <stop offset="1" stopColor="#c455ec" />
            </linearGradient>
          </defs>
          <circle className="apti-loader__draw apti-loader__track" cx="60" cy="60" r="52" />
          <g className="apti-loader__sweep">
            <circle
              className="apti-loader__draw apti-loader__arc"
              cx="60"
              cy="60"
              r="52"
              pathLength="100"
              style={{ stroke: `url(#${gradientId})` }}
            />
          </g>
          <path
            className="apti-loader__draw apti-loader__a"
            pathLength="1"
            d="M42 85 L60 36 L78 85"
          />
          <path
            className="apti-loader__draw apti-loader__a apti-loader__a2"
            pathLength="1"
            d="M50 68 H70"
          />
        </svg>
      </div>
      {showWordmark && <p className="apti-loader__word">aptiview</p>}
      {message ? <p className="apti-loader__msg">{message}</p> : null}
    </div>
  );
}
